export const GET_RETAILER_ACCOUNT = 'GET_RETAILER_ACCOUNT'
export const GET_RETAILER_ACCOUNT_FULFILLED = 'GET_RETAILER_ACCOUNT_FULFILLED'
export const GET_RETAILER_ACCOUNT_REJECTED = 'GET_RETAILER_ACCOUNT_REJECTED'
/**
 * Get retailer account by id or slug
 * @param {{id: string|number, [fields]: string[]}} payload
 */
export const getRetailerAccount = (payload) => ({
  type: GET_RETAILER_ACCOUNT,
  payload,
})

export const GET_ALLOCATION_DETAILS = 'GET_ALLOCATION_DETAILS'
export const GET_ALLOCATION_DETAILS_FULFILLED =
  'GET_ALLOCATION_DETAILS_FULFILLED'
export const GET_ALLOCATION_DETAILS_REJECTED = 'GET_ALLOCATION_DETAILS_REJECTED'
/**
 * Get facebook local ads funds by retailer account
 * @param {{id: string}} payload
 */
export const getAllocationDetails = (payload) => ({
  type: GET_ALLOCATION_DETAILS,
  payload,
})

export const GET_RETAILER_ALERTS = 'GET_RETAILER_ALERTS'
export const GET_RETAILER_ALERTS_FULFILLED = 'GET_RETAILER_ALERTS_FULFILLED'
export const GET_RETAILER_ALERTS_REJECTED = 'GET_RETAILER_ALERTS_REJECTED'
/**
 * Get alerts by retailer account
 * id: of retailer account,
 * fields: additional information to retrieve
 * @param {{id: string, fields: string[]}} payload
 */
export const getRetailerAlerts = (payload) => ({
  type: GET_RETAILER_ALERTS,
  payload,
})

export const MARK_ALERT = 'MARK_ALERT'
export const MARK_ALERT_FULFILLED = 'MARK_ALERT_FULFILLED'
export const MARK_ALERT_REJECTED = 'MARK_ALERT_REJECTED'
/**
 * Mark alert as read
 * id: of alert,
 * status: status of the alert - 'read' or 'unread'
 * @param {{id: string, status: string, retailerAccountId: string}} payload
 */
export const markAlert = (payload) => ({ type: MARK_ALERT, payload })

export const MARK_ALL_ALERTS_AS_READ = 'MARK_ALL_ALERTS_AS_READ'
export const MARK_ALL_ALERTS_AS_READ_FULFILLED =
  'MARK_ALL_ALERTS_AS_READ_FULFILLED'
export const MARK_ALL_ALERTS_AS_READ_REJECTED =
  'MARK_ALL_ALERTS_AS_READ_REJECTED'
/**
 * Mark all alerts as read
 * id: of retailer account
 * @param {{id: string}} payload
 */
export const markAllAlertsAsRead = (payload) => ({
  type: MARK_ALL_ALERTS_AS_READ,
  payload,
})
